import { createContext, useContext, useState } from 'react';

const HostPresenceContentContext = createContext();

const initialState = {
  selectedTab: 'presence',
  previousPresenceHistory: [],
  previousTaskHistory: [],
};

const getInitialFilterState = () => {
  const now = new Date();
  return {
    page: 1,
    limit: 15,
    startDate: new Date(now.getFullYear(), now.getMonth(), 1).toISOString(),
    endDate: new Date().toISOString(),
  };
};

const HostPresenceContentProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(getInitialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  const resetFilterState = () => setFilterState(getInitialFilterState);

  return (
    <HostPresenceContentContext.Provider value={{ state, updateState, filterState, updateFilterState, resetFilterState }}>
      {children}
    </HostPresenceContentContext.Provider>
  );
};

export const useHostPresenceContentState = () => {
  return useContext(HostPresenceContentContext);
};

export default HostPresenceContentProvider;
